import * as React from "react";
import { cn } from "@/lib/utils";
import { DatePicker } from "../molecules/inputs/DatePicker";
import { Label } from "../atoms/texts/label";

const Input = React.forwardRef(
  ({ className, type, value, name, error, doNotReturnDatePicker, onChange, disabled, ...props }, ref) => {
    if (type === "date" && !doNotReturnDatePicker && !disabled) {
        // console.log("DatePicker rendered with value:", value, value ? new Date(value) : undefined);
      return (
        <DatePicker
          className={className}
          date={value ? new Date(value) : undefined}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
      );
    }

    return (
      <input
        type={type}
        className={cn(
          "flex justify-beetween w-full rounded-md border  px-3 py-2 text-body ring-offset-primary file:border-0 file:bg-transparent file:text-body file:font-medium  placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-medium focus-visible:ring-offset-2 disabled:cursor-not-allowed bg-white disabled:bg-medium disabled:border-grey disabled:text-disabled",
          className
        )}
        ref={ref}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
